/**
 * The wall clock behind "Saved 2m ago" (SE-8389 AC7): re-read once a minute
 * while a save exists to age, and only while the consumer is mounted.
 * @module features/scouting/hooks/usePitchSaveClock
 */
import { useEffect, useState } from "react";

/** One minute — the grain of the relative status text. */
const TICK_MS = 60_000;

/**
 * Wall clock for the relative save status.
 * @param savedAt - Epoch milliseconds of the last successful save, if any
 * @returns Epoch milliseconds, never older than the save it ages
 */
export const usePitchSaveClock = (savedAt?: number): number => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (savedAt === undefined) return undefined;
    const interval = setInterval(() => setNow(Date.now()), TICK_MS);
    return () => clearInterval(interval);
  }, [savedAt]);
  // A save that just landed is newer than the last tick; reading it as the
  // floor keeps "Saved just now" honest without a state write in an effect.
  return Math.max(now, savedAt ?? 0);
};
